<template>
    <div>
        <!--展示-->
        <div class="Show">
            <van-nav-bar
                    :title="title"
                    left-text=""
                    left-arrow
                    @click-left="$router.back(-1)">
                <van-icon name="add-o" slot="right" style="margin-right: 5px;" @click="addExpresses()"></van-icon>
                <van-icon name="free-postage" slot="right" @click="showSelect = true"></van-icon>
            </van-nav-bar>
            <van-actionsheet
                v-model="showSelect"
                :actions="actions"
                cancel-text="关闭" :close-on-click-overlay="false"
                @select="onSelectExp">   
            </van-actionsheet>
            <div class="cmain pend_main">
                <van-collapse v-model="collapseNames">
                    <van-collapse-item title="包裹筛选" value="条件" name="1">
                        <van-cell-group>
                            <van-field v-model="filter.Keywords" label="关键字" 
                                placeholder="请输入关键字" clearable />
                            <van-field v-model="filter.BeginDate" @click="showDatetimePicker(1)"
                                label="开始日期" placeholder="请选择开始日期" clearable />
                            <van-field v-model="filter.EndDate" @click="showDatetimePicker(2)" 
                                label="结束日期" placeholder="请选择结束日期" clearable />
                            <van-cell class="search_btn">
                                <van-button type="info" @click="search()">确定</van-button>
                            </van-cell>
                        </van-cell-group>
                    </van-collapse-item>
                </van-collapse>
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="--- 没有数据了 ---"
                    @load="onLoad"
                    >
                    <van-cell-group v-for="(expItem, index) in parcelList" @click="showPopup(expItem, index)">
                        <van-cell>
                            <span class="orderid" slot="title">包裹号</span>
                            <span class="money">{{expItem.id}}</span>
                        </van-cell>
                        <div class="products">
                            <dl v-for="item in expItem.items">
                                <dt>{{item.productName}}</dt>
                                <dd>x{{item.quantity}}</dd>
                                <div class="clearb"></div>
                            </dl>
                        </div>
                        <van-cell v-if="parkageType === 1" class="small time">
                            <span slot="title">重量</span>
                            <span>{{expItem.weight}}<span v-if="expItem.weight">kg</span></span>
                        </van-cell>
                        <van-cell class="small">
                            <span slot="title">包裹状态</span>
                            <span class="paystate payunfinished" :class="{payfinished: expItem.status == 4 || expItem.status == 8}">{{expItem.statusDesc}}</span>
                        </van-cell>
                        <van-cell class="small">
                            <span slot="title">支付状态</span>
                            <span class="paystate payunfinished" :class="{payfinished: expItem.ispaid}">{{expItem.ispaid ? "已支付" : "未支付"}}</span>
                        </van-cell>
                        <van-cell class="small time">
                            <span slot="title">收件人</span>
                            <span>{{expItem.addressee && expItem.addressee.name}}</span>
                        </van-cell>
                        <van-cell v-if="expItem.expressNo" class="small time">
                            <span slot="title">{{expItem.expressTypeDesc || '快递单号'}}</span>
                            <span>{{expItem.expressNo}}</span>
                        </van-cell>
                        <van-cell class="small time">
                            <span slot="title">备注</span>
                            <span>{{expItem.remark}}</span>
                        </van-cell>
                        <van-cell class="small time">
                            <span slot="title">创建时间</span>
                            <span>{{expItem.auCreationTime}}</span>
                        </van-cell>
                        <van-cell v-if="parkageType === 0 && expItem.packedTime" class="small time">
                            <span slot="title">邮寄时间</span>
                            <span>{{expItem.packedTime}}</span>
                        </van-cell>
                    </van-cell-group>
                </van-list>
                <div style="height: 60px"></div>
            </div>
            <van-popup class="pend_opera" v-model="popupIsShow" position="bottom">
                <div class="">
                    <van-cell-group>
                        <van-cell>
                            <div class="title">包裹号：{{ expId }}</div>
                        </van-cell>
                        <van-cell v-if="isShowExpressBtn">
                            <van-button type="primary" @click="showExpProgress()">查看运单</van-button>
                        </van-cell>
                        <!--<van-cell v-if="parkageType === 1">
                            <van-button type="info" @click="toUpdate()">更新包裹</van-button>
                        </van-cell>-->
                        <van-cell>
                            <van-button type="info" @click="toCopy()">复制包裹</van-button>
                        </van-cell>
                        <van-cell v-if="curExpItem.status < 2">
                            <van-button type="danger" @click="toDelete()">删除包裹</van-button>
                        </van-cell>
                        <van-cell v-if="curExpItem.status < 8">
                            <van-button type="primary" plain  @click="showRemark()">修改备注</van-button>
                        </van-cell>
                        <van-cell v-if="curExpItem.status === 0">
                            <van-button type="info" plain  @click="share()">分享给代理点</van-button>
                        </van-cell>
                        <van-cell v-if="curExpItem.status === 1">
                            <van-button type="danger" plain @click="unShare()">取消分享</van-button>
                        </van-cell>
                        <van-cell>
                            <van-button type="default" @click="toClose()">关闭</van-button>
                        </van-cell>
                    </van-cell-group>
                </div>
            </van-popup>
            <!--选择收件人-->
            <cpnpeceiptor :isChoiseReceiptor="receiptorDialogVisible"
                v-on:choisedReceiptor="choiseReceiptor" v-on:closeRecPopup="closeRecPopup"></cpnpeceiptor>
        </div>
        <!--时间选择-->
        <datetimepicker :isShowDatetimePicker="isShowDatetimePicker" 
            :dateType="dateType" :currentDate="currentDate"
            v-on:closeDatetimePicker="closeDatetimePicker"></datetimepicker>
        <!--显示运单-->
        <van-popup v-model="isShowExpProgress" position="top" @click-overlay="toClose" style="max-height: 80%; padding: 8px 0;">
            <expprogess :expProgressId="expProgressId"></expprogess>
        </van-popup>
        <!--邮单操作界面-->
        <van-popup v-model="isShowExpReceiptor" class="Show" position="right" style="width: 100%; height: 100%;">
            <van-nav-bar
                title="邮单"
                left-text=""
                left-arrow
                @click-left="toClodeExpReceiptor()" />
            <div class="cmain">
                <div class="exp_title">收件人</div>
                <van-cell value="选择收件人" icon="user-circle-o" is-link @click="showReceiptor">
                    <template slot="title">
                        <span class="custom-title">{{ dialogData.items.addressee.name }} </span>
                        <van-tag type="danger" v-if="dialogData.items.addressee.tel">{{ dialogData.items.addressee.tel }}</van-tag>
                    </template>
                </van-cell>
                <div class="exp_title">寄件人</div>
                <van-cell-group>
                    <van-field
                        v-model="dialogData.items.consignor.name"
                        clearable
                        label="姓名"
                        placeholder="请输入寄件人姓名"
                    />

                    <van-field
                        v-model="dialogData.items.consignor.tel"
                        clearable
                        label="电话"
                        placeholder="请输入寄件人电话"
                    />
                </van-cell-group>
                <div class="exp_title">商品</div>
                <van-field
                    clearable left-icon="search" @click="showExpSearchProduct"
                    placeholder="请输入关键词搜索商品">
                    <van-button slot="button" size="small" type="primary" @click="showExpCreateProduct">新增商品</van-button>
                </van-field>
                <van-row style="height: 2.5rem; line-height: 2.5rem; background: #e1ecf5;">
                    <van-col span="1">&nbsp;</van-col>
                    <van-col span="12" align="center">产品名称</van-col>
                    <van-col span="8" align="center">数量</van-col>
                    <van-col span="3" align="center">操作</van-col>
                </van-row>
                <div style="height: 3rem; line-height: 3rem; text-align: center;" v-if="dialogData.items.commodities.length <= 0">暂无数据~</div>
                <van-row class="exp_products" v-else v-for="(pro, pIndex) in dialogData.items.commodities">
                    <van-col span="1">&nbsp;</van-col>
                    <van-col span="12" style="padding-top:.3rem;">{{ pro.commodityName }}</van-col>
                    <van-col span="8" align="center">
                        <van-stepper v-model="pro.quantity" integer :min="1" />
                    </van-col>
                    <van-col span="3" align="center" style="padding-top:.4rem;">
                        <van-icon name="clear" color="red" size="1.4rem" @click="deleteCommodity(pro, pIndex)"/>
                    </van-col>
                </van-row>
                <!--<van-row class="exp_products">
                    <van-col span="1">&nbsp;</van-col>
                    <van-col span="12" style="padding-top:.3rem;">MiniJumbuk 凉爽羊毛被（二层）Cool Single单人150cm x 200cm</van-col>
                    <van-col span="8" align="center">
                        <van-stepper v-model="value" integer :min="1" />
                    </van-col>
                    <van-col span="3" align="center" style="padding-top:.4rem;"><van-icon name="clear" color="red" size="1.4rem" /></van-col>
                </van-row>-->
                <div class="exp_btn_box">
                    <van-button type="primary" size="large" @click="saveExp()">保存</van-button>
                </div>
            </div>
        </van-popup>
        <!--商品搜索界面-->
        <van-popup v-model="isShowExpSearch" class="Show" position="right" style="width: 100%; height: 100%;">
            <van-nav-bar
                title="商品搜索"
                left-text=""
                left-arrow
                @click-left="closeExpSearchProduct()" />
            <div class="cmain">
                <van-field
                    v-model="productKeyword"
                    clearable @input="querySearchProduct"
                    left-icon="search"
                    placeholder="请输入关键词搜索商品">
                </van-field>
                <div style="height: 3rem; line-height: 3rem; text-align: center;" v-if="allSearchProducts.length <= 0">暂无数据~</div>
                <van-row class="exp_search_products" v-else v-for="pro in allSearchProducts" @click.native="selectSearchProduct(pro)">
                    <van-col span="1">&nbsp;</van-col>
                    <van-col span="3" align="center" class="image"><img :src="pro.imageUrl" /></van-col>
                    <van-col span="1">&nbsp;</van-col>
                    <van-col span="18" class="title">{{ pro.value }}</van-col>
                    <van-col span="1">&nbsp;</van-col>
                </van-row>
                <!--<van-row class="exp_search_products">
                    <van-col span="1">&nbsp;</van-col>
                    <van-col span="3" align="center" class="image"><img src="https://www.baidu.com/img/dong_a16028f60eed614e4fa191786f32f417.gif" /></van-col>
                    <van-col span="1">&nbsp;</van-col>
                    <van-col span="18" class="title">MiniJumbuk 凉爽羊毛被（二层）Cool Single单人150cm x 200cm</van-col>
                    <van-col span="1">&nbsp;</van-col>
                </van-row>-->
            </div>
        </van-popup>
        <!--新增商品界面-->
        <van-popup v-model="isShowExpCreate" class="Show" position="top" style="width: 100%; height: 100%;">
            <van-nav-bar
                title="新增商品"
                left-text=""
                left-arrow
                @click-left="closeExpCreateProduct()" />
            <div class="cmain">
                <van-cell-group>
                    <van-field
                        v-model="dialogExpressProducts.brand"
                        clearable
                        label="品牌"
                        placeholder="请输入品牌名称"
                    />
                    <van-field
                        v-model="dialogExpressProducts.name"
                        clearable
                        label="名称"
                        placeholder="请输入商品名称"
                    />
                    <van-field
                        v-model="dialogExpressProducts.baseSpecs"
                        clearable
                        label="规格"
                        placeholder="请输入商品规格"
                    />
                </van-cell-group>
                <div class="exp_btn_box">
                    <van-button type="primary" size="large" @click="saveProduct()">保存商品</van-button>
                    <van-button type="default" size="large" @click="closeExpCreateProduct">关闭</van-button>
                </div>
            </div>
        </van-popup>
        <!--修改备注-->
        <van-popup v-model="isShowExpRemark" class="Show" position="bottom" @click-overlay="hideRemark" style="width: 100%;">
            <van-nav-bar
                title="修改备注"
                left-text="" />
            <div class="cmain">
                <van-field v-model="expRemark" label="备注" type="textarea" 
                placeholder="请输入备注" rows="5" autosize />
                <div class="exp_btn_box">
                    <van-button type="primary" size="large" @click="saveRemark()">保存备注</van-button>
                    <van-button type="default" size="large" @click="hideRemark()">关闭</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import moment from 'moment'
    import { Cell, CellGroup, Collapse, CollapseItem, DatetimePicker, Row, Col, Stepper, Tag } from 'vant';
    import cpnpeceiptor from '@/views/m/components/receiptor.vue'
    import datetimepicker from '@/views/m/components/datetimePicker.vue'
    import expprogess from '@/views/m/components/expProgress.vue'
    export default {
        name: "mexpresses",
        components: {
            cpnpeceiptor,
            datetimepicker,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [DatetimePicker.name]: DatetimePicker,
            [Row.name]: Row,
            [Col.name]: Col,
            [Stepper.name]: Stepper,
            [Tag.name]: Tag,
            expprogess
        },
        data() {
            return {
                list: [],
                loading: false,
                finished: false,
                title: "",
                filter:{
                    Status: null,
                    BeginDate:null,
                    EndDate:null,
                    Keywords:null,
                    Page:1,
                    Size:10
                },
                popupIsShow: false,
                expId: "", // 包裹号
                popupDetailIsShow: false,
                orderDetail: {},
                receiptorDialogVisible: false, //联系人
                isUpdateOrDetail: 1,
                collapseNames: [], 
                isShowDatetimePicker: false, //显示日期选择控件
                dateType: "date",   //日期选择控件类型
                currentDate: new Date(),
                currentType: 0, //当前点击的时间是开始还是结束

                curIndex: null,
                parcelList: [],
                parkageType: 0,
                expProgressId: null,
                isShowExpProgress: false,
                isShowExpressBtn: false,
                showSelect: false,
                actions: [
                    { name: '所有包裹' },
                    { name: '待寄包裹' }
                ],
                isShowExpReceiptor: false, // 显示邮单
                isShowExpSearch: false, // 商品搜索
                isShowExpCreate: false, // 创建商品
                dialogData: {
                    title: '邮单',
                    items: {
                        memberId: 0,
                        consignor: {
                            name: '',
                            tel: ''
                        },
                        addressee: {
                            id: 0,
                            name: '',
                            tel: '',
                            province: '',
                            city: '',
                            area: '',
                            detail: '',
                            idCardNo: '',
                            idCardFrontImageUrl: '',
                            idCardBackImageUrl: ''
                        },
                        commodities: []
                    }
                },
                dialogExpressProducts: {
                    name: '',
                    brand: '',
                    baseSpecs: null,
                    id: 0
                },
                productKeyword: "", //搜索关键字
                allSearchProducts: [],   //所有搜索出来的商品
                isShowExpRemark: false, // 显示备注
                expRemark: "", // 弹出的备注内容
                curExpItem: {status:0} // 当前对象
            }
        },
        mounted() {
            let query = this.$route.query;
            let status = this.$route.params.status;
            this.filter.Status = !isNaN(status) && status > 0 ? status : null;
            switch(parseInt(this.filter.Status)) {
                case 1:
                    this.title = this.actions[1].name;
                    this.parkageType = 1
                    break;
                default:
                    this.title = this.actions[0].name;
                    this.parkageType = 0
            }
            this.getMyInfo()
        },
        methods: {
            onLoad() {
                this.showH5Loading();
                let pars = JSON.parse(JSON.stringify(this.filter));
                pars.Status = this.parkageType === 1 ? 7 : null
                if (moment(this.filter.EndDate).isValid()) {
                    pars.EndDate = moment(this.filter.EndDate).format("YYYY-MM-DD 23:59:59");
                }
                this.$axios.get(window.consts.apis.getParcelList, {params: pars}).then(r=>{
                    this.loading = false
                    this.hideH5Loading()
                    if(r.success){
                        this.parcelList = this.parcelList.concat(r.result.items)
                        if(this.parcelList.length >= r.result.totalCount){
                            this.finished = true
                        } else {
                            this.filter.Page++
                            this.finished = false
                        }
                        //this.filter.Page++
                    } else{
                        this.$dialog.alert({ message: r.error.message });
                    }
                })
            },
            getMyInfo() {
                this.$axios.get(window.consts.apis.getMyInfo).then(res => {
                    if (res.success) {
                        this.dialogData.items.memberId = res.result.id
                        this.dialogData.items.consignor.name = res.result.consignor.name
                        this.dialogData.items.consignor.tel = res.result.consignor.tel
                    }
                })
            },
            showPopup(item, index) {
                this.curIndex = index
                this.curExpItem = item
                this.expId = item.id
                this.isShowExpressBtn = item.expressNo ? true : false
                this.popupIsShow = true
            },
            toClose() {
                this.curIndex = null
                this.popupIsShow = false
                this.expId = ""
                this.isShowExpressBtn = false
            },
            search() {
                this.filter.Page = 1
                this.parcelList = []
                this.collapseNames = []
                this.finished = true
                this.onLoad();
            },
            showDatetimePicker(type) {
                this.currentType = type
                this.isShowDatetimePicker = true
            },
            // 关闭时间日期选择
            closeDatetimePicker(data) {
                this.isShowDatetimePicker = false
                if (!data || !moment(data).isValid()) {
                    return false
                }
                data = moment(data).format("YYYY-MM-DD");
                if (this.currentType === 1) {
                    this.filter.BeginDate = data
                } else if(this.currentType === 2) {
                    this.filter.EndDate = data
                }
                if (moment(this.filter.BeginDate).isAfter(this.filter.EndDate)) {
                    this.filter.EndDate = null
                    this.$toast.fail("结束日期不能小于开始日期!")
                }
            },
            // 选择包裹类别
            onSelectExp(item) {
                location.href = '/m/expresses/' + (item.name == this.actions[0].name ? 0 : 1)
            },
            // 打开收件人操作界面
            showReceiptor() {
                this.receiptorDialogVisible = true
            },
            // 选择收件人
            choiseReceiptor(item) {
                this.dialogData.items.addressee = item.addressee
                this.dialogData.items.addressee.id = item.id
                this.closeRecPopup(false);
                return false;
            },
            // 关闭收件人界面
            closeRecPopup(data) {
                this.receiptorDialogVisible = data;
            },
            // 添加邮单
            addExpresses() {
                for (var i in this.dialogData.items.addressee) {
                    this.dialogData.items.addressee[i] = ''
                }
                //this.dialogData.items.consignor.name = ''
                //this.dialogData.items.consignor.tel = ''
                this.dialogData.items.commodities = []
                this.isShowExpReceiptor = true
            },
            // 获取邮单详细信息
            getDetailExpresses(isCopy) {
                this.showH5Loading();
                this.dialogData.items.commodities = []
                this.$axios.get(window.consts.apis.getParcelById + '?id=' + this.expId).then(res => {
                    this.hideH5Loading()
                    if (res.success) {
                        for (var i in this.dialogData.items) {
                            if (res.result[i]) {
                                this.dialogData.items[i] = res.result[i]
                            }
                        }
                        if (isCopy) {
                            this.dialogData.items.memberId = 0
                        }
                        for (var i in res.result.items) {
                            var item = res.result.items[i]
                            var temp = {}
                            temp.productId = item.productId
                            temp.commodityName = item.productName
                            temp.quantity = item.quantity
                            this.dialogData.items.commodities.push(temp)
                        }
                    } else {
                        this.$dialog.alert({message: res.error.message})
                        return false
                    }
                }).catch(e => {
                    this.hideH5Loading()
                    this.$toast.fail('获取邮单失败!')
                    return false
                })
                this.isShowExpReceiptor = true
            },
            // 关闭添加邮单界面
            toClodeExpReceiptor() {
                this.isShowExpReceiptor = false
            },
            // 显示底部弹出的操作按钮
            showExpProgress() {
                this.expProgressId = this.expId
                this.isShowExpProgress = true
            },
            // 更新邮单
            toUpdate() {
                this.getDetailExpresses()
            },
            // 复制邮单
            toCopy() {
                this.getDetailExpresses(true)
            },
            // 删除邮单
            toDelete() {
                this.$dialog.confirm({
                    message: '确定要删除邮单吗？'
                }).then(() => {
                    this.showH5Loading()
                    this.$axios.delete(window.consts.apis.deleteParcel, {params: {id: this.expId}}).then(r => {
                        this.hideH5Loading()
                        if (r.success) {
                            let item = r.result;
                            this.$toast.success({
                                duration: 2000,
                                forbidClick: true,
                                loadingType: 'spinner',
                                message: "删除成功!",
                                onClose: (rt => {
                                    this.parcelList.splice(this.curIndex, 1)
                                    this.toClose();
                                })
                            });
                        } else {
                            this.$dialog.alert({ message: r.error.message })
                            return false;
                        }
                    }).catch(e => {
                        this.hideH5Loading();
                        this.$toast.fail("出错啦，请稍候再试!");
                        return false;
                    })
                }).catch(() => {
                    
                });
            },
            // 打开商品搜索
            showExpSearchProduct() {
                this.isShowExpSearch = true
            },
            // 关闭商品搜索
            closeExpSearchProduct() {
                this.allSearchProducts = []
                this.productKeyword = ""
                this.isShowExpSearch = false
            },
            // 选择搜索的商品
            selectSearchProduct(obj) {
                var id = obj.id
                //console.log(obj)
                for (var i in this.dialogData.items.commodities) {
                    var productId = this.dialogData.items.commodities[i].productId
                    if (id === productId) {
                        this.$dialog.alert({ message: '该产品已添加，请在表格中进行修改和删除!' })
                        this.closeExpSearchProduct()
                        return false
                    }
                }
                var temp = {}
                temp.productId = obj.id
                temp.commodityName = obj.value
                temp.quantity = 1
                this.dialogData.items.commodities.push(temp)
                this.closeExpSearchProduct()
            },
            // 获取搜索的商品
            querySearchProduct(val) {
                this.allSearchProducts = []
                if (!val) {
                    return false
                }
                this.productKeyword = val
                var query = {keywords: val, takeNum: 30}
                this.$axios.get(window.consts.apis.getParcelProduct, {params: query}).then(res => {
                    if (res.success) {
                        for (var i in res.result) {
                            var item = res.result[i]
                            var temp = {}
                            temp.id = item.id
                            temp.value = item.commodityName
                            temp.imageUrl = item.imageUrl
                            this.allSearchProducts.push(temp)
                        }
                    } else {
                        this.$dialog.alert({ message: res.error.message })
                        return false
                    }
                }).catch(e => {
                    this.$toast.fail("产品加载出错!");
                    return false
                })
            },
            // 显示新增商品
            showExpCreateProduct() {
                this.isShowExpCreate = true
            },
            closeExpCreateProduct() {
                for(let i in this.dialogExpressProducts) {
                    this.dialogExpressProducts[i] = null
                }
                this.dialogExpressProducts.id = 0
                this.isShowExpCreate = false
            },
            // 保存商品
            saveProduct() {
                this.showH5Loading();
                this.$axios.post(window.consts.apis.createExpressProduct, this.dialogExpressProducts).then(res => {
                    this.hideH5Loading()
                    if (res.success) {
                        let item = res.result;
                        this.$toast.success({
                            duration: 2000,
                            forbidClick: true,
                            loadingType: 'spinner',
                            message: "添加成功!",
                            onClose: (rt => {
                                let temp = {}
                                temp.productId = item.id
                                temp.commodityName = item.commodityName
                                temp.quantity = 1
                                this.dialogData.items.commodities.push(temp)
                                this.closeExpCreateProduct();
                            })
                        });
                    } else {
                        this.$dialog.alert({ message: res.error.message });
                        return false
                    }
                }).catch(e => {
                    this.hideH5Loading();
                    this.$toast.fail("出错啦，请稍候再试!");
                    return false
                })
            },
            // 保存邮单
            saveExp() {
                console.log(this.dialogData.items)
                if (!this.dialogData.items.addressee.name || !this.dialogData.items.addressee.tel) {
                    this.$toast.fail('请选择收件人!')
                    return false
                }
                if (!this.dialogData.items.consignor.name || !this.dialogData.items.consignor.tel) {
                    this.$toast.fail('请填写寄件人信息!')
                    return false
                }
                if (this.dialogData.items.commodities.length <= 0) {
                    this.$toast.fail('请添加寄件产品!')
                    return false
                }
                this.showH5Loading()
                //this.dialogData.items.addressee.id
                this.$axios.post(window.consts.apis.submitParcel, this.dialogData.items).then(res => {
                    this.hideH5Loading()
                    if (res.success) {
                        let item = res.result;
                        this.$toast.success({
                            duration: 2000,
                            forbidClick: true,
                            loadingType: 'spinner',
                            message: "操作成功!",
                            onClose: (rt => {
                                this.toClodeExpReceiptor()
                                this.toClose()
                                this.search()
                            })
                        });
                    } else {
                        this.$toast.fail('操作失败，请稍候再试!')
                        return false
                    }
                }).catch(e => {
                    this.hideH5Loading()
                    this.$toast.fail('出错啦，请稍候再试!')
                    return false
                })
            },
            // 删除商品
            deleteCommodity(item, index) {
                this.dialogData.items.commodities.splice(index, 1)
            },
            // 显示修改备注框
            showRemark() {
                this.expRemark = this.curExpItem.remark
                this.isShowExpRemark = true
            },
            // 隐藏修改备注框
            hideRemark(index, isSuccess, curRemark) {
                var index = index || this.curIndex
                var temp = {};
                for (var i in this.parcelList[index]) {
                    temp[i] = this.parcelList[index][i];
                }
                this.isShowExpRemark = false
                // 如果是修改成功
                if (isSuccess) {
                    temp.remark = curRemark
                    this.$set(this.parcelList, index, temp);
                    this.toClose()
                    return false
                }
                this.expRemark = ""
            },
            // 保存修改备注
            saveRemark() {
                var id = this.expId
                var index = this.curIndex
                var curRemark = this.expRemark
                var temp = {
                    id: id,
                    remark: curRemark
                }
                this.showH5Loading();
                this.$axios.put(window.consts.apis.updateRemark, temp).then(res => {
                    this.hideH5Loading();
                    if (res.success) {
                        this.$toast.success({
                            duration: 2000,
                            forbidClick: true,
                            loadingType: 'spinner',
                            message: "备注修改成功!",
                            onClose: (rt => {
                                this.hideRemark(index, true, curRemark);
                            })
                        });
                    } else {
                        this.$dialog.alert({ message: res.error.message });
                    }
                }).catch(e => {
                    this.hideH5Loading()
                    this.$toast.fail('出错啦，请稍候再试!')
                    return false
                })
            },
            share() {
                let ids = [this.expId]
                var index = this.curIndex
                this.showH5Loading()
                this.$axios.post(window.consts.apis.shareToShop, ids).then(res => {
                    this.hideH5Loading()
                    if (res.success) {
                        this.$toast.success({
                            duration: 2000,
                            forbidClick: true,
                            loadingType: 'spinner',
                            message: "分享成功!",
                            onClose: (rt => {
                                this.toClose()
                                this.search()
                            })
                        })
                    } else {
                        this.$dialog.alert({ message: res.error.message });
                        return false
                    }
                }).catch(e => {
                    this.hideH5Loading()
                    this.$toast.fail('出错啦，请稍候再试!')
                    return false
                })
            },
            unShare() {
                let ids = [this.expId]
                var index = this.curIndex
                this.showH5Loading()
                this.$axios.post(window.consts.apis.cancelShareToShop, ids).then(res => {
                    this.hideH5Loading()
                    if (res.success) {
                        this.$toast.success({
                            duration: 2000,
                            forbidClick: true,
                            loadingType: 'spinner',
                            message: "撤销分享成功!",
                            onClose: (rt => {
                                this.toClose()
                                this.search()
                            })
                        })
                    } else {
                        this.$dialog.alert({ message: res.error.message });
                        return false
                    }
                }).catch(e => {
                    this.hideH5Loading()
                    this.$toast.fail('出错啦，请稍候再试!')
                    return false
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pend_main,.pend_detail {
        .van-cell-group {
            margin-top: 15px;
            border-top: 1px solid #ddd;
            border-bottom: 1px solid #ccc;
        }
        .van-collapse {
            .van-cell-group {
                margin-top: 5px;
                border: 0;
                .van-field {
                    border-bottom: 1px dotted #999;
                }
            }
        }
        .small {
            padding: 5px 15px;
            .van-field {
                padding: 0 15px;
            }
        }
        .time {
            .van-cell__value {
                flex: 2;
            }
        }
        .orderid {
            font-size: 16px;
            font-weight: 700;
            color: #262626;
        }
        .money {
            font-size: 16px;
            font-weight: bold;
            color: #f21c0d;
        }
        .paystate {
            padding: 3px 8px;
            color: #fff;
        }
        .payunfinished {
            background: #ee722b;
        }
        .payfinished {
            background: #55edc3;
        }
        .products {
            margin: 0;
            padding: 10px 15px;
            background:#f5f5f5;
            dl {
                margin: 6px 0;
                padding: 0;
            }
            dt {
                margin: 0;
                padding: 0;
                float: left;
                width: 88%;
            }
            dd {
                margin: 0;
                padding: 0;
                line-height: 1.5;
                float: right;
                color: #999;
            }
        }
    }
    .pend_opera {
        .title {
            padding: 10px 0;
            font-size: 14px;
            text-align: center; 
            color: #999;
        }
        .van-cell {
            padding: 5px 15px;
        }
        .van-button {
            width: 100%;
        }
    }
    .pend_detail {
        .van-popup {
            width: 100%;
            height: 100%;
        }
        .van-nav-bar {
            position: absolute;
        }
        .detailmain {
            margin-top: 46px;
            height: calc(100% - 46px);
            overflow-y: auto;
        }
        .grouptitle {
            background:#eee;
            font-size: 16px;
            padding:10px 15px;
            color: #1ab394;
        }
        .remark {
            padding:10px 15px;
            min-height: 50px;
            line-height: 1.6;
        }
    }
    .pend_main {
        padding-top: 46px;
        .van-collapse {
            position: fixed;
            top: 46px;
            left: 0;
            width: 100%;
            z-index: 1000;
        }
        .search_btn {
            .van-button {
                width: 100%;
            }
        }
    }
    .van-nav-bar__text { color: #fff; }
    .exp_title {
        padding: 10px 15px; color: #1ab394;
    }
    .exp_products {
        padding: 5px 0; font-size: 0.8rem; border-bottom: 1px solid #fff; background: #fff;
    }
    .exp_search_products {
        height: 4rem;
        border-bottom: 1px solid #fff;
        .image {
            margin-top: 0.4rem;
            height: 3.2rem;
            img {
                max-width: 100%;
                height: 100%;
            }
        }
        .title {
            margin-top: 0.5rem;
            line-height: 1.5rem;
        }
    }
    .exp_btn_box {
        width: 96%;
        margin:10px auto 0;
        button {
            margin:0 auto 10px;
        }
    }
</style>

